const Color = {
  PRIMARY: '#FFBD2F',
  PRIMARY_TRANSLUCENT: 'rgba(255,189,47,0.25)',
  PRIMARY_TRANSLUCENT_LIGHT: 'rgba(255,189,47,0.25)',
  PRIMARY_TRANSLUCENT_DARK: 'rgba(255,189,47,0.75)',
  WHITE: '#FFFFFF',
  BLACK: '#000000',
  GREY_FONT: '#B8B8B8',
  GREY_FONT_LIGHT: '#B8B8B8',
  GREY_FONT_DARK: '#474747',
  DARK_OVERLAY: 'rgba(0,0,0,0.5)',
  DIVIDER: '#EFEFEF',
  DIVIDER_LIGHT: '#EFEFEF',
  DIVIDER_DARK: '#303030',
  IOS_KEYBOARD_BG_DARK_DARK: '#1C1C1C',
  IOS_KEYBOARD_BG_DARK_LIGHT: '#3A3A3A',
  IOS_KEYBOARD_BG_LIGHT_DARK: '#CED1D6',
  IOS_KEYBOARD_BG_LIGHT_LIGHT: '#CED1D6',
  IOS_KEYBOARD_BTN_DARK_DARK: '#616161',
  IOS_KEYBOARD_BTN_DARK_LIGHT: '#757575',
  IOS_KEYBOARD_BTN_LIGHT_DARK: '#FFFFFF',
  IOS_KEYBOARD_BTN_LIGHT_LIGHT: '#FFFFFF',
};

export default Color;
